import { defineAsyncComponent } from '../compat/vueCompat';
import type { ItemUploadDialogRequest, ItemUploadRequestPayload } from './itemUploadDialogRequest';
import { requestDialog } from './requestDialog';

const ItemUploadDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/ItemUploadDialog.vue'));

/**
 * Show the upload dialog for n amount of files that a user has selected/dropped
 * @param files The files that were selected
 * @param targetFolderId If present, the target folder the items should be placed in
 * @param placeholderId If present, the target item that the item should be uploaded to
 * @param placeholderExpectedType If present, the expected type of the target placeholder.
 */
export function showItemUploadDialog(payload: ItemUploadRequestPayload) {
  const req: ItemUploadDialogRequest = {
    ...payload,
  };
  requestDialog(req, ItemUploadDialog);
}
